import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { StyledDateMonthPicker } from "./style";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useAllQueryParams from "hooks/useGetAllQueryParams/useAllQueryParams";

interface IDateYearFilter {
  defaultValue?: Dayjs | undefined;
  clearable?: boolean;
  filterName?: string;
  type?: "year" | "month" | "day" | "date";
}
const DateDayFilter = ({
  defaultValue,
  clearable = false,
  filterName = "date",
  type = "day",
}: IDateYearFilter) => {
  const [value, setValue] = useState<Dayjs | undefined>(defaultValue);
  const [__, setSearchParams] = useSearchParams();
  const allParams = useAllQueryParams();

  const onChange = (date: any) => {
    if (date) {
      setValue(date);
      setSearchParams({
        ...allParams,
        [filterName]:
          type === "year"
            ? dayjs(date).get("year") + ""
            : type === "month"
            ? dayjs(date).get("month") + 1 + ""
            : type === "day"
            ? dayjs(date).get("date") + ""
            : dayjs(date).toISOString(),  
      });
    } else {
      setValue(undefined);
      delete allParams[filterName];
      setSearchParams({
        ...allParams,
      });
    }
  };

  useEffect(() => {
    if (defaultValue) {
      setSearchParams({
        ...allParams,
        [filterName]:
          type === "year"
            ? dayjs(defaultValue).get("year") + ""
            : type === "month"
            ? dayjs(defaultValue).get("month") + 1 + ""
            : type === "day"
            ? dayjs(defaultValue).get("date") + ""
            : dayjs(defaultValue).toISOString(),  
      });
    } else if (allParams[filterName]) {
      setValue(dayjs(allParams[filterName]));
    }
  }, []);

  return (
    <StyledDateMonthPicker>
      <DatePicker
        value={value}
        onChange={onChange}
        picker={type === "day" ? "date" : type}
        allowClear={clearable}
        format={
          type === "month"
            ? "MM" 
            : type === "year"
            ? "YYYY" 
            : type === "day"
            ? "YYYY-MM-DD" 
            : "YYYY-MM-DD" 
        }
        aria-readonly
      />
    </StyledDateMonthPicker>
  );
};

export default DateDayFilter;
